<script>
import PickList from "primevue/picklist";
import Listbox from "primevue/listbox";
import Button from "primevue/button";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import hOSAvatar from "@/components/hOSAvatar.vue";
import Panel from "primevue/panel";
import ToggleSwitch from "primevue/toggleswitch";
import Popover from "primevue/popover";

export default {
  props: ['people', 'users', 'teams', 'teamable'],
  emits: ["people:add", "people:remove", "teams:toggle"],
  components: {PickList, Listbox, Button, DataTable, Column, hOSAvatar, ToggleSwitch, Popover, Panel},
  data: () => ({
    selectedPeople: [],
    selectedUsers: [],
    expandedRowGroups: []
  }),
  updated() {
  },
  computed: {
    teamable() {
      return typeof this.$props.teams !== 'undefined';
    },
    notInGroup() {
      this.selectedUsers = [];
      const peopleIds = this.people.map(p => p.id);
      return this.people
          ? this.users.filter(u => !peopleIds.includes(u.id))
          : this.users;
    },
  },
  methods: {
    showAddPeoplePopover(event) {
      this.$refs.addUsersPopover.show(event);
    },
    addPeople() {
      this.$emit('people:add', this.selectedUsers);
      this.selectedUsers = [];
      this.$refs.addUsersPopover.hide();
    },

    removePeople() {
      this.$emit('people:remove', this.selectedPeople);
      this.selectedPeople = [];
    },

  }
}
</script>
<template>
<div>
  <Popover ref="addUsersPopover" @hide="selectedUsers = []">
    <Listbox v-model="selectedUsers"
             v-model:expandedRowGroups="expandedRowGroups"
             :options="notInGroup"
             optionLabel="name"
             placeholder="Add user"
             list-style="max-height: 30rem"
             multiple filter>
      <template #option="slotProps">
        <div class="flex items-center gap-2">
          <hOSAvatar :user="slotProps.option"/>
          <span>{{ slotProps.option.name }}</span>
        </div>
      </template>
    </Listbox>
    <div class="flex justify-end">
      <Button label="Add" @click="addPeople"/>
    </div>
  </Popover>
  <Panel header="People">
    <template #header>
      <div class="flex gap-2 items-center">
        <span class="p-panel-title">People</span>
        <Button severity="secondary" rounded outlined icon="pi pi-user-plus" @click="showAddPeoplePopover"
                v-tooltip.top="'Add users'"/>
        <Button severity="danger" rounded outlined icon="pi pi-user-minus" @click="removePeople"
                v-tooltip.top="'Remove selected'"
                :disabled="selectedPeople?.length == 0"/>

      </div>
    </template>
    <template #icons>
      <div class="flex items-center gap-1" v-if="teamable">
        <ToggleSwitch v-bind:model-value="teams" inputId="teams-toggle" @change="$emit('teams:toggle', !teams)"/>
        <label for="teams-toggle">Teams</label>
      </div>
    </template>
    <DataTable :value="people"
               v-model:selection="selectedPeople"
               selection-mode="multiple"
               striped-rows
               :pt="{thead: {style: 'display: none'}}"
               scrollable scroll-height="40rem"
               :row-group-mode="teams ? 'subheader' : ''"
               :group-rows-by="teams ? 'teamObj.name' : ''"
              :sort-field="'name'"
               :multi-sort-meta="[{field: 'teamObj.name', order: 1}, {field: 'name', order: 1}]"
              :sort-order="1"
              :sort-mode="teams ? 'multiple' : 'single'">

      <template #groupheader="slotProps">
        <strong>{{ slotProps.data.teamObj?.name || '(no team)' }}</strong>
      </template>
      <Column selection-mode="multiple" style="width: 3em"/>
      <Column field="teamObj.name" header="Team" style="width: 3rem" v-if="teams"/>
      <Column style="width: 3rem">
        <template #body="slotProps">
          <hOSAvatar :user="slotProps.data"/>
        </template>
      </Column>
      <Column field="name"></Column>

    </DataTable>
  </Panel>
</div>
</template>
